import { Box, Typography, Link } from '@mui/material';

import { FormControlProps } from '../control';
import { FormComponentBuilder } from '../index';
import useBundleTranslation from 'i18n';

export default function FormConciergeSetupDescription() {
    const { t } = useBundleTranslation('form');
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                width: '100%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        >
            <Box sx={{ textAlign: 'center' }}>
                <Typography fontWeight={600}>{t('concierge_desc.not_configurable_here')}</Typography>
                <Typography>{t('concierge_desc.all_settings')}</Typography>
                <Link sx={{ textDecoration: 'underline' }} target={'_blank'} href={'/admin/concierge#connection'}>
                    {t('concierge_desc.concierge_setup_page')}
                </Link>
            </Box>
        </Box>
    );
}

export class FormConciergeSetupDescriptionBuilder extends FormComponentBuilder {
    prepareProps(): FormControlProps {
        return {
            ...this.controlProps,
        };
    }
}
